export default __webpack_public_path__ + "static/media/gq.e3b821bf.svg";